import type { State } from '../types.tsx';

export const getCollectionsIsLoading = (state: State) => state.collections.isLoading;

export const getCollectionsData = (state: State) => state.collections.data;
